import React, { useState } from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";

import s from "./Dropdown.scss";

const Dropdown = ({
  dropClassName,
  mouseOutHandler,
  mouseOverHandler,
  anchor,
  className = "",
  isRelative = true,
  defaultActive = false,
  children,
  ...rest
}) => {
  const [active, setActive] = useState(defaultActive);

  const handleMouseLeave = () => {
    setActive(false);
  };

  const handleMouseOver = () => {
    setActive(true);
  };

  const handleClick = () => {
    setActive(!active);
  };

  const childrenWithProps = React.Children.map(children, (child, i) => {
    let classNameChild = child.props.className || "";
    if (anchor) classNameChild += ` anchor-${anchor}`;
    if (active) {
      classNameChild += i === 0 ? " --isActive" : ` ${dropClassName}`;
      anchor;
    }

    if (i === 0) {
      return React.cloneElement(child, {
        onClick: handleClick,
        className: classNameChild
      });
    }
    return React.cloneElement(child, { className: classNameChild });
  });

  return (
    <button
      className={cx("Dropdown", { "--isRelative": isRelative }, className)}
      type="button"
      {...rest}
      onMouseLeave={mouseOutHandler ? handleMouseLeave : undefined}
      onMouseOver={mouseOverHandler ? handleMouseOver : undefined}
    >
      {childrenWithProps}
    </button>
  );
};

export default withStyles(s)(Dropdown);



// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js